import React, { useEffect, useState } from 'react';
import { TimerIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34; // 00:17:34

function pad(value: number) {
  return value.toString().padStart(2, '0');
}

/**
 * Counts down from 00:17:34 and restarts automatically when it hits zero.
 */
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const blocks = [{
    value: pad(hours),
    label: 'Horas'
  }, {
    value: pad(minutes),
    label: 'Min'
  }, {
    value: pad(seconds),
    label: 'Seg'
  }];
  return <div className="mt-5 w-full" data-id="element-18" data-mp="2zrnptz5y72k1">
      <p className="mb-3 flex items-center justify-center gap-2 text-[11px] font-bold uppercase tracking-widest text-red-600 sm:text-xs" data-id="element-19" data-mp="2zsqh4876n70h">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-20" data-mp="1c2rodql26p7l" />
        Esta oferta expira en
      </p>
      <div className="flex items-start justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Oferta expira en ${pad(hours)} horas ${pad(minutes)} minutos ${pad(seconds)} segundos`} data-id="element-21" data-mp="1gxotwnj4qgfq">
        {blocks.map((block, index) => <React.Fragment key={block.label} data-id="element-22" data-mp="1urohvs8mtdor" data-mpi={index}>
            <div className="flex min-w-[60px] flex-col items-center rounded-2xl bg-navy-900 px-3 py-2 sm:min-w-[76px] sm:px-4 sm:py-3" data-id="element-23" data-mp="1zpzto8ihly9m">
              <span className="font-display text-2xl font-black tabular-nums text-white sm:text-4xl" data-id="element-24" data-mp="1l0licuvcp6rl">
                {block.value}
              </span>
              <span className="mt-0.5 text-[9px] font-bold uppercase tracking-widest text-navy-200 sm:text-[10px]" data-id="element-25" data-mp="2dq0uxp2nz7pm">
                {block.label}
              </span>
            </div>
            {index < blocks.length - 1 && <span className="pt-2 font-display text-2xl font-black text-navy-300 sm:pt-3 sm:text-4xl" data-id="element-26" data-mp="2sczkfehyns1p">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}